import React, { FC, ReactNode } from 'react'

import { ErrorBoundary } from '@shared/lib/components/ErrorBoundary'
import ContentLoader from 'react-content-loader'
import {
  SKELETON_FOREGROUND_COLOR,
  SKELETON_MAIN_COLOR,
  SKELETON_SPEED,
  SKELETON_STYLES,
} from '@shared/consts/skeleton'
import { useCurrentSize } from '@shared/lib/helpers/classes'
import { CardTwoBlockSkeleton } from '@shared/ui/Layout/CardTwoBlock'
import s from '@widgets/Restaurant/RestCards/RestCard/ui/CardTypes/Template/Template.module.sass'

export interface TemplateCardProps {
  sizes: string // L ML M S
  children?: ReactNode
  className?: string
  animate?: boolean
}

const Skeleton: FC<
  TemplateCardProps & React.DetailedHTMLProps<React.HTMLAttributes<HTMLAnchorElement>, HTMLAnchorElement>
> = ({ sizes, children, className = '', animate = true }) => {
  const [size] = useCurrentSize(sizes)

  const defaultAttributes = {
    rx: '8',
    ry: '8',
    'data-size': size,
  }
  return (
    <ErrorBoundary>
      <CardTwoBlockSkeleton sizes={sizes} className={`${s.card} ${className}`} animate={animate}>
        <CardTwoBlockSkeleton.Img />

        <CardTwoBlockSkeleton.Content className={s.content}>
          {children || (
            <>
              <rect className={`${s['skeleton-item']} ${s['skeleton-item--1']}`} {...defaultAttributes} />
              <rect className={`${s['skeleton-item']} ${s['skeleton-item--2']}`} {...defaultAttributes} />
              <rect className={`${s['skeleton-item']} ${s['skeleton-item--3']}`} {...defaultAttributes} />
            </>
          )}
        </CardTwoBlockSkeleton.Content>
      </CardTwoBlockSkeleton>
    </ErrorBoundary>
  )
}

export default Skeleton
